import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Amplify } from 'aws-amplify'
import awsExports from './aws-exports'

// Soft UI Context Provider
import { SoftUIControllerProvider } from 'context'

// console.log(awsExports)
// console.log(window.location.href)
// const signInUri = {
//   oauth: {
//     redirectSignIn: 'https://app.goparco.com/dashboard',
//   },
// }
// const mergedConfig = {
//   ...awsExports,
//   oauth: {
//     ...awsExports.oauth,
//     ...signInUri.oauth,
//   },
// }
// Amplify.configure(mergedConfig)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // Temporarily Remove this for charts
  // <React.StrictMode>
  <SoftUIControllerProvider>
    <App />
  </SoftUIControllerProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
